/** Default language code used to initialize the shell and user settings. */
export const defaultLanguage = 'CS';

/** Base spacing unit used across shell and feature layouts. */
export const gutter = 8;
/** Double base spacing unit used for larger shell gaps. */
export const doubleGutter = 16;

/** Interval between FE version checks in milliseconds. */
export const versionCheckInterval = 1800000;
